import { Prospect } from '../types';

export const mockProspects: Record<string, Prospect> = {
  'vibe-store': {
    id: 'prsp_vibestore_01',
    name: 'Urban Pulse Moda LTDA',
    trade_name: 'Urban Pulse',
    slug: 'urban-pulse',
    segment: 'Moda Fitness, Roupas e Vestuário',
    city: 'São Miguel do Oeste',
    state: 'SC',
    address: 'Rua Santos Dumont, 868, sala 102 - Centro - CEP 89900-000',
    phone: '(49) 99117-2320',
    whatsapp: '554988416296',
    instagram: 'https://instagram.com/vibestore_br',
    tagline: 'Energia que te veste. Estilo que te representa.',
    verification_status: 'VERIFIED',
    status: 'ACTIVE',
    theme: {
      primary_color: '#00C4B4',
      accent_color: '#0891B2',
      bg_color: '#FFFFFF',
      surface_color: '#F8FAFC',
      text_color: '#0F172A',
      font_heading: 'Outfit',
      font_body: 'Inter'
    },
    datasetId: 'turquesa',
    availableDemos: ['ecommerce', 'biolink'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  'move-collection': {
    id: 'prsp_move_01',
    name: 'Aura Fit & Casual',
    trade_name: 'Aura Fit',
    slug: 'aura-fit',
    segment: 'Moda fitness, roupas femininas, roupas esportivas e vestuário',
    city: 'São Miguel do Oeste',
    state: 'SC',
    address: 'Rua Sete de Setembro, 2321, Centro - São Miguel do Oeste - SC, CEP 89900-000',
    phone: '(49) 93300-1095',
    whatsapp: '554988416296',
    instagram: 'https://instagram.com/movecollection_br',
    tagline: 'Moda feminina com atitude. Do treino ao dia a dia.',

    verification_status: 'AGUARDANDO VERIFICAÇÃO',
    status: 'ACTIVE',
    sources: [
      {
        id: 'src_bym_google_01',
        prospect_id: 'prsp_bymary_01',
        source_type: 'Google Business Profile',
        verified_at: new Date().toISOString(),
        verified_by: 'System',
        notes: 'DADO CONFLITANTE — AGUARDANDO CONFIRMAÇÃO. Telefone Google: (49) 93300-1095. Existe ação "Site" a ser verificada.'
      },
      {
        id: 'src_bym_insta_01',
        prospect_id: 'prsp_bymary_01',
        source_type: 'Instagram Profile',
        source_url: 'https://instagram.com/bymaryfitness',
        verified_at: new Date().toISOString(),
        verified_by: 'System',
        notes: 'DADO CONFLITANTE — AGUARDANDO CONFIRMAÇÃO. Telefone Perfil: +55 49 92000-3239.'
      }
    ],
    business_hours: 'Terça-feira: 08:30 às 12:00 | 13:30 às 19:30',
    theme: {
      primary_color: '#047857',
      accent_color: '#84CC16',
      secondary_color: '#D97706',
      bg_color: '#FDFBF7',
      surface_color: '#FFFFFF',
      text_color: '#1C1917',
      font_heading: 'Outfit',
      font_body: 'Inter'
    },
    datasetId: 'turquesa', // Assuming fallback to turquesa products for demo
    availableDemos: ['ecommerce', 'biolink'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  'multimarcas-viagens': {
    id: 'prsp_multimarcas_01',
    name: 'Odisséia Turismo',
    trade_name: 'Odisséia',
    slug: 'odisseia',
    segment: 'Agência de viagens e experiências',
    city: 'São Miguel do Oeste',
    state: 'SC',
    address: 'Rua Dom José Garrido Yanes, 222, Centro - São Miguel do Oeste - SC, CEP 89900-000',
    phone: '(49) 3197-0245',
    whatsapp: '554988416296',
    instagram: 'https://instagram.com/multimarcas_viagens',
    tagline: 'Tecnologia para ampliar o cuidado, não para substituir pessoas.',
    verification_status: 'AGUARDANDO VERIFICAÇÃO',
    status: 'ACTIVE',
    sources: [
      {
        id: 'src_mult_insta_01',
        prospect_id: 'prsp_multimarcas_01',
        source_type: 'Instagram Profile',
        source_url: 'https://instagram.com/multimarcas_viagens',
        verified_at: new Date().toISOString(),
        verified_by: 'System',
        notes: 'DADO CONFLITANTE — AGUARDANDO CONFIRMAÇÃO. Telefone comercial: (49) 3197-0245, Plantão: (49) 99987-1586. Mais de 7 anos. Agentes: Elisandra, Kalane, Maria.'
      }
    ],
    theme: {
      primary_color: '#FCD34D',
      accent_color: '#FDE68A',
      bg_color: '#0A0A0A',
      surface_color: '#171717',
      text_color: '#FAFAFA',
      font_heading: 'Playfair Display',
      font_body: 'Inter'
    },
    availableDemos: ['site'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  'atlas-viagens': {
    id: 'prsp_atlas_01',
    name: 'Meridiano Viagens',
    trade_name: 'Meridiano',
    slug: 'meridiano',
    segment: 'Agência de viagens e turismo.',
    city: 'Chapecó',
    state: 'SC',
    address: 'Av. Getúlio Vargas, 1316, Centro - Chapecó — SC',
    phone: '(49) 3025-2488',
    whatsapp: '554988416296',
    instagram: 'https://instagram.com/atlas.viagens',
    tagline: 'Sua próxima aventura começa aqui. Pacotes nacionais e internacionais com atendimento personalizado.',

    verification_status: 'AGUARDANDO VERIFICAÇÃO',
    status: 'ACTIVE',
    sources: [
      {
        id: 'src_emb_site_01',
        prospect_id: 'prsp_embarque_01',
        source_type: 'Website',
        verified_at: new Date().toISOString(),
        verified_by: 'System',
        notes: 'DADO CONFLITANTE — AGUARDANDO CONFIRMAÇÃO. Endereço: Av. Getúlio Dorneles Vargas, 1316, Centro - Chapecó — SC'
      },
      {
        id: 'src_emb_insta_01',
        prospect_id: 'prsp_embarque_01',
        source_type: 'Instagram Profile',
        source_url: 'https://instagram.com/embarque22',
        verified_at: new Date().toISOString(),
        verified_by: 'System',
        notes: 'DADO CONFLITANTE — AGUARDANDO CONFIRMAÇÃO. Endereço: Av. Getúlio Dorneles Vargas, 1291N, Centro - Chapecó — SC. Seguidores: ~22k. Clientes embarcados: >15k.'
      }
    ],
    theme: {
      primary_color: '#06B6D4', // Azul-ciano vibrante
      accent_color: '#0891B2', // Azul profundo
      secondary_color: '#2DD4BF', // Verde-aqua
      bg_color: '#FFFFFF', // Branco
      surface_color: '#F8FAFC', // Cinzas muito claros
      text_color: '#0F172A',
      font_heading: 'Outfit',
      font_body: 'Inter'
    },
    availableDemos: ['site'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  'santoriny-shoes': {
    id: 'prsp_santoriny_01',
    name: 'Maison Claire Calçados',
    trade_name: 'Maison Claire',
    slug: 'maison-claire',
    segment: 'Calçados Premium Femininos',
    city: 'São Miguel do Oeste',
    state: 'SC',
    address: 'Rua Almirante Barroso, 660, Centro - São Miguel do Oeste - SC, CEP 89900-000',
    phone: '(49) 99949-3361',
    whatsapp: '554988416296',
    instagram: 'https://instagram.com/santoriny.shoes',
    tagline: 'Curadoria com cuidado em cada detalhe.',
    verification_status: 'AGUARDANDO VERIFICAÇÃO',
    status: 'ACTIVE',
    sources: [
      {
        id: 'src_san_insta_01',
        prospect_id: 'prsp_santoriny_01',
        source_type: 'Instagram Profile',
        source_url: 'https://instagram.com/santoriny.shoes',
        verified_at: new Date().toISOString(),
        verified_by: 'System',
        notes: 'DADO OBSERVADO — Endereço: Rua Almirante Barroso, 660, Centro.'
      },
      {
        id: 'src_san_google_01',
        prospect_id: 'prsp_santoriny_01',
        source_type: 'Google Business Profile',
        verified_at: new Date().toISOString(),
        verified_by: 'System',
        notes: 'DADO OBSERVADO — Avaliação: 5.0 (16 avaliações). Telefone: (49) 99949-3361.'
      },
      {
        id: 'src_san_brands_01',
        prospect_id: 'prsp_santoriny_01',
        source_type: 'Public Communication',
        verified_at: new Date().toISOString(),
        verified_by: 'System',
        notes: 'AGUARDANDO CONFIRMAÇÃO — Marcas mencionadas: Luiza Barcelos, Schutz, Carrano, Jorge Bischoff, Marina Mello.'
      }
    ],
    theme: {
      primary_color: '#1E3A8A', // Azul intenso/profundo
      accent_color: '#1D4ED8', // Azul royal
      secondary_color: '#D4AF37', // Bege quente/Dourado suave
      bg_color: '#FFFFFF', // Branco
      surface_color: '#F9FAFB', // Off-white
      text_color: '#171717', // Preto suave
      font_heading: 'Playfair Display', // Serif editorial
      font_body: 'Inter' // Sans-serif limpa
    },
    datasetId: 'santoriny',
    availableDemos: ['ecommerce', 'biolink'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  'doha-shoes': {
    id: 'prsp_doha_01',
    name: 'Stile Milano',
    trade_name: 'Stile Milano',
    slug: 'stile-milano',
    segment: 'Moda e Calçados Multimarcas',
    city: 'São Miguel do Oeste',
    state: 'SC',
    address: 'Rua Almirante Barroso, 581, Centro - São Miguel do Oeste - SC, CEP 89900-000',
    phone: '(49) 3621-3099',
    whatsapp: '554988416296',
    instagram: 'https://instagram.com/shoes.doha',
    tagline: 'O melhor da moda multimarcas.',
    verification_status: 'AGUARDANDO VERIFICAÇÃO',
    status: 'ACTIVE',
    sources: [
      {
        id: 'src_doha_insta_01',
        prospect_id: 'prsp_doha_01',
        source_type: 'Instagram Profile',
        source_url: 'https://instagram.com/shoes.doha',
        verified_at: new Date().toISOString(),
        verified_by: 'System',
        notes: 'DADO OBSERVADO — Endereço: Rua Almirante Barroso, 581, Centro.'
      },
      {
        id: 'src_doha_google_01',
        prospect_id: 'prsp_doha_01',
        source_type: 'Google Business Profile',
        verified_at: new Date().toISOString(),
        verified_by: 'System',
        notes: 'DADO OBSERVADO — Telefone Google: (49) 3621-3099.'
      },
      {
        id: 'src_doha_brands_01',
        prospect_id: 'prsp_doha_01',
        source_type: 'Public Communication',
        verified_at: new Date().toISOString(),
        verified_by: 'System',
        notes: 'AGUARDANDO CONFIRMAÇÃO — Marcas mencionadas: Arezzo, Santa Lolla, Vicenza, Anacapri, Osklen, Colcci.'
      }
    ],
    theme: {
      primary_color: '#111111', // Preto Carvão
      accent_color: '#000000', // Preto Puro
      secondary_color: '#D4AF37', // Dourado muito discreto
      bg_color: '#FAFAFA', // Off-white/Marfim
      surface_color: '#FFFFFF', // Branco
      text_color: '#111111', // Preto Carvão
      font_heading: 'Inter',
      font_body: 'Inter'
    },
    datasetId: 'doha',
    availableDemos: ['ecommerce', 'biolink'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  'forte-gym': {
    id: 'prsp_forte_01',
    name: 'Titanium Fitness Club',
    trade_name: 'Titanium Gym',
    slug: 'titanium-gym',
    segment: 'Academias e CrossFit',
    city: 'São Miguel do Oeste',
    state: 'SC',
    address: 'Rua Willy Barth, 1200 - São Miguel do Oeste - SC',
    phone: '(49) 3622-1000',
    whatsapp: '554988416296',
    instagram: 'https://instagram.com/fortegym_br',
    tagline: 'Sua melhor versão é construída aqui. Todo dia.',

    verification_status: 'AGUARDANDO VERIFICAÇÃO',
    status: 'ACTIVE',
    sources: [
      {
        id: 'src_apolo_insta_01',
        prospect_id: 'prsp_apolo_01',
        source_type: 'Instagram Profile',
        source_url: 'https://instagram.com/mundoapolo',
        verified_at: new Date().toISOString(),
        verified_by: 'System',
        notes: 'DADO OBSERVADO — Segmento fitness, foco em crosstraining e condicionamento.'
      }
    ],
    theme: {
      primary_color: '#FF4500',
      accent_color: '#FF6347',
      secondary_color: '#F8FAFC',
      bg_color: '#FFFFFF',
      surface_color: '#F8FAFC',
      text_color: '#0F172A',
      font_heading: 'Inter',
      font_body: 'Inter'
    },
    availableDemos: ['app'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  'vanguard-imoveis': {
    id: 'prsp_vanguard_01',
    name: 'Skyline Empreendimentos',
    trade_name: 'Skyline',
    slug: 'skyline-imoveis',
    segment: 'Imobiliária de Alto Padrão',
    city: 'Balneário Camboriú',
    state: 'SC',
    address: 'Av. Atlântica, 4000 - Centro',
    phone: '(47) 99999-0000',
    whatsapp: '554988416296',
    instagram: 'https://instagram.com/vanguard.imoveis',
    tagline: 'Onde arquitetura encontra o horizonte.',
    verification_status: 'AGUARDANDO VERIFICAÇÃO',
    status: 'ACTIVE',
    theme: {
      primary_color: '#0F172A',
      accent_color: '#C5A880',
      secondary_color: '#334155',
      bg_color: '#FAFAFA',
      surface_color: '#FFFFFF',
      text_color: '#111111',
      font_heading: 'Playfair Display',
      font_body: 'Inter'
    },
    datasetId: 'vanguard',
    availableDemos: ['imobiliaria', 'app', 'sistema', 'biolink'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  'oral-clin': {
    id: 'prsp_oralclin_01',
    name: 'Lumina Odontologia Avançada',
    trade_name: 'Lumina Odontologia',
    slug: 'lumina',
    segment: 'Odontologia e Saúde',
    city: 'Curitiba',
    state: 'PR',
    address: 'Av. do Batel, 1550 - Batel',
    phone: '(41) 3333-0000',
    whatsapp: '554988416296',
    instagram: 'https://instagram.com/oralclin',
    tagline: 'Seu sorriso é a nossa maior especialidade.',
    verification_status: 'AGUARDANDO VERIFICAÇÃO',
    status: 'ACTIVE',
    theme: {
      primary_color: '#0D9488', // Teal
      accent_color: '#0EA5E9', // Light Blue
      secondary_color: '#334155', // Slate
      bg_color: '#FFFFFF', // White
      surface_color: '#F8FAFC', // Slate 50
      text_color: '#334155', // Slate 700
      font_heading: 'Plus Jakarta Sans',
      font_body: 'Inter'
    },
    datasetId: 'oralclin',
    availableDemos: ['clinica', 'app', 'sistema', 'biolink'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  'fogao-vivo': {
    id: 'prsp_fogaovivo_01',
    name: 'Brasa & Sal Gastronomia',
    trade_name: 'Brasa & Sal',
    slug: 'brasa-sal',
    segment: 'Gastronomia, Hamburgueria & Delivery',
    city: 'Chapecó',
    state: 'SC',
    address: 'Av. Getúlio Vargas, 1400 - Centro',
    phone: '(49) 3322-5000',
    whatsapp: '554988416296',
    instagram: 'https://instagram.com/fogaovivo.ch',
    tagline: 'Hambúrguer artesanal grelhado no fogo de verdade. Sem frescura.',

    verification_status: 'AGUARDANDO VERIFICAÇÃO',
    status: 'ACTIVE',
    theme: {
      primary_color: '#EA580C',
      accent_color: '#F59E0B',
      secondary_color: '#FFF7ED',
      bg_color: '#FFFFFF',
      surface_color: '#FFF7ED',
      text_color: '#1C1917',
      font_heading: 'Outfit',
      font_body: 'Inter'
    },
    datasetId: 'bruta',
    availableDemos: ['gastronomia', 'app', 'sistema', 'biolink'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  'vanguard-advocacia': {
    id: 'prsp_vanguardlaw_01',
    name: 'Montebello & Partners',
    trade_name: 'Montebello Advocacia',
    slug: 'montebello',
    segment: 'Advocacia Corporativa & Advisory',
    city: 'São Paulo',
    state: 'SP',
    address: 'Av. Brigadeiro Faria Lima, 3477 - 12º andar - Itaim Bibi',
    phone: '(11) 3040-0000',
    whatsapp: '554988416296',
    instagram: 'https://instagram.com/vanguard.advocacia',
    tagline: 'Segurança jurídica e excelência corporativa para grandes negócios.',
    verification_status: 'AGUARDANDO VERIFICAÇÃO',
    status: 'ACTIVE',
    theme: {
      primary_color: '#0F172A', // Navy Slate 900
      accent_color: '#C5A880', // Warm Gold/Beige
      secondary_color: '#334155', // Slate 700
      bg_color: '#F8FAFC', // Slate 50 Off-white
      surface_color: '#FFFFFF',
      text_color: '#0F172A',
      font_heading: 'Playfair Display',
      font_body: 'Inter'
    },
    datasetId: 'vanguardlaw',
    availableDemos: ['advocacia', 'app', 'sistema', 'biolink'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  'vanguard-motors': {
    id: 'prsp_vanguardmotors_01',
    name: 'Apex Motors & Supercars LTDA',
    trade_name: 'Apex Motors',
    slug: 'apex-motors',
    segment: 'Automóveis, Concessionárias & Garagens de Luxo',
    city: 'São Paulo',
    state: 'SP',
    address: 'Av. Europa, 780 - Jardins',
    phone: '(11) 3080-0000',
    whatsapp: '554988416296',
    instagram: 'https://instagram.com/vanguard.motors',
    tagline: 'Superesportivos e blindados com garantia de procedência.',
    verification_status: 'AGUARDANDO VERIFICAÇÃO',
    status: 'ACTIVE',
    theme: {
      primary_color: '#DC2626', // Red Sport
      accent_color: '#E2E8F0', // Chrome/Platinum
      secondary_color: '#18181B',
      bg_color: '#09090B', // Dark High-Tech
      surface_color: '#18181B',
      text_color: '#FFFFFF',
      font_heading: 'Outfit',
      font_body: 'Inter'
    },
    datasetId: 'vanguardmotors',
    availableDemos: ['automoveis', 'app', 'sistema', 'biolink'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
  'vanguard-arquitetura': {
    id: 'prsp_vanguardarch_01',
    name: 'Oasis Studio de Arquitetura',
    trade_name: 'Oasis Studio',
    slug: 'oasis-studio',
    segment: 'Arquitetura, Interiores & Gestão de Obras',
    city: 'São Paulo',
    state: 'SP',
    address: 'Alameda Gabriel Monteiro da Silva, 1890 - Jardim Paulistano',
    phone: '(11) 3060-0000',
    whatsapp: '554988416296',
    instagram: 'https://instagram.com/vanguard.arquitetura',
    tagline: 'Arquitetura autoral e interiores de alto padrão.',
    verification_status: 'AGUARDANDO VERIFICAÇÃO',
    status: 'ACTIVE',
    theme: {
      primary_color: '#1A1A1A', // Deep Graphite
      accent_color: '#D4C5B9', // Mineral Beige
      secondary_color: '#C86D51', // Terracotta
      bg_color: '#FAF9F6', // Off-White
      surface_color: '#FFFFFF',
      text_color: '#1A1A1A',
      font_heading: 'Playfair Display',
      font_body: 'Inter'
    },
    datasetId: 'vanguardarch',
    availableDemos: ['arquitetura', 'app', 'sistema', 'biolink'],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  },
};
